import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";
import {useNaikPangkatPrediksiListModel} from "@/stores/models/naik-pangkat-prediksi-list-model";

export const useNaikPangkatPrediksiListStore  = defineStore(
    'naikPangkatPrediksiListStore',
    () => {
       
        const isLoading = ref(false);
        const dataSourceNaikPangkatPrediksiList = ref(
            new DataSource({
                requireTotalCount: true,
                store: useNaikPangkatPrediksiListModel().naikPangkatPrediksiListCustomStore,
                filter: null,
            })
        );
        const state = ref(true);
        const onMuatButtonClick =()=>{
            state.value = false;
            dataSourceNaikPangkatPrediksiList.value.reload();
        };

        const initialized = ()=>{     
            dataSourceNaikPangkatPrediksiList.value.reload();
        };

        const dataSourceNaikPangkatPrediksiListArray = (additionalParamsFilter = null, additionalParamsSort = null) => {
            return useNaikPangkatPrediksiListModel().naikPangkatPrediksiListArray(additionalParamsFilter, additionalParamsSort);
        };

        const dataSourceNaikPangkatPrediksiListUpdate = (key = null, values = null) => {
            return useNaikPangkatPrediksiListModel().naikPangkatPrediksiListUpdate(key, values);
        };

        const tetapkan = (key = null) => {
            return useNaikPangkatPrediksiListModel().naikPangkatPrediksiTetapkan(key);
        }

        const sinkron = (key = null, updatedByUserId) => {
            return useNaikPangkatPrediksiListModel().naikPangkatPrediksiSinkron(key, updatedByUserId);
        }

        return {
            dataSourceNaikPangkatPrediksiListUpdate,
            tetapkan,
            sinkron,
            dataSourceNaikPangkatPrediksiListArray,
            dataSourceNaikPangkatPrediksiList,
            isLoading,
            onMuatButtonClick,
            initialized,
            state

        }
    }
);